define(function (require, exports, module) {
    var AppConsole = require('app-console/app-console');

    return new AppConsole({ns: 'Game Data Pacemaker', level: 'global'});
});
